import type { Metadata } from "../next/types";
import { useSiteStylesheet } from "../next/stylesheet";

export const SITE_URL = "https://jamestown.ng";

const SITE_TITLE =
  "Jamestown | Trade Bitcoin, USDT & USDC in Nigeria";

const SITE_DESCRIPTION =
  "Trade Bitcoin, USDT and USDC with naira on Jamestown. Explore crypto-to-naira rates, gift cards and crypto learning tools built for Nigeria.";

export const metadata: Metadata = {
  metadataBase: new URL(SITE_URL),

  title: {
    default: SITE_TITLE,
    template: "%s | Jamestown",
  },

  description: SITE_DESCRIPTION,

  applicationName: "Jamestown",

  robots: {
    index: true,
    follow: true,
    googleBot: {
      index: true,
      follow: true,
      "max-image-preview": "large",
      "max-snippet": -1,
      "max-video-preview": -1,
    },
  },

  openGraph: {
    type: "website",
    siteName: "Jamestown",
    locale: "en_NG",
    title: SITE_TITLE,
    description: SITE_DESCRIPTION,
    url: SITE_URL,
  },

  twitter: {
    card: "summary_large_image",
    title: SITE_TITLE,
    description: SITE_DESCRIPTION,
  },
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  // globals.css is compiled separately (scripts/build-site-css.js) and linked
  // here; pages wait for it so they never paint unstyled.
  const ready = useSiteStylesheet();
  return ready ? <>{children}</> : <div style={{ minHeight: "100vh", background: "#080318" }} />;
}
